<style src="./Editor.scss" lang="scss"></style>

<template lang="pug">
  form.editor(
    :class='{ "is-loading": loading }'
  )
    .editor__header
      .editor__cover
        ImageUpload(
          :image='getCover()'
          @update-cover='updateCover'
        )
      .editor__fields
        .editor__field
          Input(
            name='name'
            :placeholder='$l10n("PLAYLIST_NAME")'
            :required='true'
            v-model='form.title'
            @input='debounced.update'
          )
    .editor__body
      .editor__search
        TrackSearchField(
          :key='playlistId'
          :playlist-id='playlistId'
        )

      .editor__tracks
        ItemList(
          type='tracks'
          view='list'
          :empty-message='$l10n("DONT_HAVE_TRACKS")'
          :key='playlistId'
          :playlist-id='playlistId'
          :items='playlistTracks'
          :tracklist='tracklist'
        )

</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Input from "@/components/Input/Input";
import ImageUpload from "@/components/ImageUpload/ImageUpload";
import ItemList from "@/components/ItemList/ItemList";
import TrackSearchField from "@/components/TrackSearchField/TrackSearchField";

import editorMixin from "@/mixins/components/editor.mixin";
import helpers from "@/services/helpers";

export default {
  props: {
    playlist: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      debounced: {
        update: null
      },
      form: {
        title: this.playlist.title,
        cover: null
      }
    };
  },
  components: {
    Input,
    ImageUpload,
    ItemList,
    TrackSearchField
  },
  computed: {
    ...mapGetters({
      tracks: "tracks/tracks"
    }),
    tracklist() {
      return {
        id: this.playlistId,
        tracks: this.playlist.tracks
      };
    },
    playlistTracks() {
      return this.playlist.tracks
        .map(id => this.tracks[id])
        .filter(track => Boolean(track));
    },
    playlistId() {
      return this.playlist.id;
    }
  },
  mixins: [editorMixin],
  methods: {
    ...mapActions({
      updatePlaylist: "playlists/update",
      removePlaylist: "playlists/remove",
      updatePlaylistCover: "playlists/updateCover"
    }),
    async remove() {
      this.loading = true;

      const { success } = await this.removePlaylist({
        playlistId: this.playlist.id
      });

      if (success) {
        this.$router.push("/");
      } else {
        this.loading = false;
      }
    },
    update() {
      this.updatePlaylist({
        id: this.playlist.id,
        title: this.form.title || this.$l10n("NO_NAME")
      });
    },
    updateCover(images) {
      if (images.length) {
        const [image] = images;

        this.updatePlaylistCover({
          id: this.playlist.id,
          image: image.file
        });
      }
    },
    getCover() {
      if (this.playlist !== null && this.playlist.cover) {
        return this.playlist.cover.medium;
      }

      return null;
    }
  },
  created() {
    this.debounced.update = helpers.debounce(() => {
      this.update();
    }, 1000);
  }
};
</script>
